import { Component, input } from '@angular/core';
import type { FormGroup } from '@angular/forms';

import type { WorkModelSectionTranslations } from '@core/locations-legacy';
import {
  WorkModelSectionComponent,
  WorkModelSectionTranslationsToken,
  WorkModelSectionViewContext,
} from '@core/locations-legacy';

import type { RequisitionForm } from '../../../requisitions.types';

const translations: WorkModelSectionTranslations = {
  heading: 'app.requisitions.details_page.work_model.heading',
  subheading: 'app.requisitions.details_page.work_model.subheading',
};

@Component({
  selector: 'rt-requisitions-work-model',
  templateUrl: './requisitions-work-model.component.html',
  styleUrls: ['./requisitions-work-model.component.less'],
  imports: [WorkModelSectionComponent],
  providers: [{ provide: WorkModelSectionTranslationsToken, useValue: translations }],
})
export class RequisitionsWorkModelComponent {
  public readonly WorkModelSectionViewContext = WorkModelSectionViewContext;

  public readonly isFormEditable = input<boolean>(undefined!);
  public readonly form = input<FormGroup<RequisitionForm>>(undefined!);

  public get workModelControl() {
    return <FormGroup>this.form().get('workModel')!;
  }
}
